import { TLMDStorage } from './storage';
/**
 * receive the localStorage item for the given key
 * @param {string} key
 * @param {*} defaultValue the default value to return if the key is not present in the locale storage
 * @returns object or array if the item was such a thing before storage, otherwise a raw string
 */
export const getStorageItem = (key:string, defaultValue?:any) : any => {
    // try to be smart, guess if it was a object or array
    let item:string  = window.localStorage.getItem(key);
    if ((typeof item)==='string') {
        // try to parse as js
        // if that fails silently fallback to simple string
        try {
            return JSON.parse(item);
        } catch (err) {
            return item;
        }
    } else { // no such item, return defaultValue if provided
        if (defaultValue)
            return defaultValue;
    }
};

/**
 * removes the given localStorage key
 * @param key
 */
export const clearStorageItem = (key:string) : void => window.localStorage.removeItem(key);

/**
 * stores an item under the given localStorage key
 * @param key {string} storage key
 * @param item item to store, either a string or an object/array (which is stringified automatically)
 */
export const setStorageItem = (key: string, item: any): void => {
    if ((typeof item) !== 'string')
        window.localStorage.setItem(key, JSON.stringify(item));
    else
        window.localStorage.setItem(key, item);
};

/**
 * print localStorage to the console
 */
export const dumpLocalStorage = () : void => {
    console.info("Contents of LocalStorage");
    for (var k = 0 ; k < window.localStorage.length ; ++k )
        console.info(window.localStorage.key(k)+" => "+window.localStorage.getItem(window.localStorage.key(k)));
};

export const localStorage : TLMDStorage = {
        getStorageItem : getStorageItem,
        setStorageItem : setStorageItem,
        clearStorageItem : clearStorageItem,
    };
